import { helmetJsonLdProp } from 'react-schemaorg';

// SCHEMAS
import movieSchema from './schemas/movieSchema';
import showSchema from './schemas/showSchema';
import faqSchema from './schemas/faqSchema';
import aboutSchema from './schemas/aboutSchema';
import contactSchema from './schemas/contactSchema';
import wpPostSchema from './schemas/wpPostSchema';
import webSiteSchema from './schemas/webSiteSchema';
import searchResultsSchema from './schemas/searchResultsSchema';
import appDetailsSchema from './schemas/appDetailsSchema';
import channelSchema from './schemas/channelSchema';
import wepPageSchema from './schemas/wepPageSchema';

export const getOrgSchema = (schemaName, data = {}) => {
  let schema;

  switch (schemaName) {
    case 'movie':
      schema = movieSchema(data);
      break;
    case 'show':
      schema = showSchema(data);
      break;
    case 'faq':
      schema = faqSchema(data);
      break;
    case 'about':
      schema = aboutSchema(data);
      break;
    case 'contact':
      schema = contactSchema(data);
      break;
    case 'wpPost':
      schema = wpPostSchema(data);
      break;
    case 'website':
      schema = webSiteSchema(data);
      break;
    case 'searchResults':
      schema = searchResultsSchema(data);
      break;
    case 'app':
      schema = appDetailsSchema(data);
      break;
    case 'channel':
      schema = channelSchema(data);
      break;
    case 'wepPage':
      schema = wepPageSchema(data);
      break;
    default:
      schema = {};
      break;
  }

  return helmetJsonLdProp({
    '@context': 'https://schema.org',
    ...schema,
  });
};

export default getOrgSchema;
